module.exports = "<p>\n    <b>“SOS MUJER” línea 137</b><br>\n    Ministerio de la Mujer<br>\n    (021) 45 20 60 | atencion@mujer.gov.py\n</p>\n\n<p>\n    <b>147 Fono Ayuda</b><br>\n    Secretaría de la Niñez y Adolescencia<br>\n    Para denuncias de hechos punibles de criadazgo o trabajo infantil\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/resultado/accordion-html/accordion-iniciativas-estatales.html
// module id = 625
// module chunks = 0